import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./sections/Footer/Footer";
import Accueil from "./pages/Accueil/Accueil";
import LegalMentions from "./pages/LegalMentions/LegalMentions";

import Header from "./sections/Header/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import BilanComportemental from "./pages/BilanComportemental/BilanComportemental";
import CoursEducation from "./pages/CoursEducation/CoursEducation";
import Partenaires from "./pages/Partenaires/Partenaires";
import RemplacementElevage from "./pages/RemplacementElevage/RemplacementElevage";
import About from "./pages/About/About";

function App() {
  return (
    <div className="App">
      <Header />
      <main className="content">
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/a-propos" element={<About />} />
          <Route
            path="/remplacement-elevage"
            element={<RemplacementElevage />}
          />
          <Route
            path="/bilan-comportemental-chiens-chats"
            element={<BilanComportemental />}
          />
          <Route
            path="/cours-education-chiens-chats"
            element={<CoursEducation />}
          />
          <Route path="/partenaires" element={<Partenaires />} />
          <Route path="/mentions-legales" element={<LegalMentions />} />
          <Route path="*" element={<div>Page non trouvée (404)</div>} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
